/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fields_RequiredInputs */

const cs_templates_fields_required = /** @type {(inputs: Templates_Fields_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povinné`)
};

const en_templates_fields_required = /** @type {(inputs: Templates_Fields_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Templates_Fields_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fields_required = /** @type {((inputs?: Templates_Fields_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fields_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fields_required(inputs)
	return cs_templates_fields_required(inputs)
});